import React, {Component} from "react";
import DataTable from 'react-data-table-component';
import {Button, Col, Container, Row} from "react-bootstrap";
import "./PolicySupportToolResult.css";
import {Line} from "react-chartjs-2";
import Form from "react-bootstrap/Form";
import axios from "axios";
import Calculator from "./Calculator";
import { BrowserRouter as Router, Link } from "react-router-dom";

const options = {
    scales: {
        yAxes: [
            {
                ticks: {
                    beginAtZero: true,
                },
            },
        ],
    }
};

const columns = [
    {
        name: 'Type',
        selector: 'impactType',
        sortable: true,
        wrap: true
    },
    {
        name: 'id',
        selector: 'id',
        sortable: true,
        maxWidth: '5px'
    },
    {
        name: 'Impact',
        selector: 'impact',
        sortable: false,
        wrap: true,
        grow: 2

    },
    {
        name: 'Description',
        selector: 'description',
        sortable: false,
        grow: 8
    },
    {
        name: 'Measurement Unit',
        selector: 'measurementUnit',
        sortable: false,
        grow: 2
    }
];

for (let i = 2020; i <= 2050; i++) {
    columns.push({
        name: '' + i,
        selector: '' + i,
        sortable: true
    });
}

class PolicySupportToolResult extends Component {

    componentDidMount() {
        this.retrieveInterventions();
    }

    state = {
        interventions: [],
        impact: '',
        policyIntervention: '',
        policyYear: '2021',
        data: null,
        withoutPolicyData: this.props.data['WITHOUT_POLICY_INTERVENTION'],
        withPolicyDataCase1: this.props.data['WITH_POLICY_INTERVENTION_CASE1'],
        withPolicyDataCase2: this.props.data['WITH_POLICY_INTERVENTION_CASE2'],
        withPolicyDataCase3: this.props.data['WITH_POLICY_INTERVENTION_CASE3'],
        withPolicyDataCase4: this.props.data['WITH_POLICY_INTERVENTION_CASE4'],
        withPolicyDataCase5: this.props.data['WITH_POLICY_INTERVENTION_CASE5'],
        withPolicyDataCase6: this.props.data['WITH_POLICY_INTERVENTION_CASE6'],
        withPolicyDataCase7: this.props.data['WITH_POLICY_INTERVENTION_CASE7'],
        withPolicyDataCase8: this.props.data['WITH_POLICY_INTERVENTION_CASE8'],
        withPolicyDataCase9: this.props.data['WITH_POLICY_INTERVENTION_CASE9'],
        withPolicyDataCase10: this.props.data['WITH_POLICY_INTERVENTION_CASE10'],
        withPolicyDataCase11: this.props.data['WITH_POLICY_INTERVENTION_CASE11'],
        withPolicyDataCase12: this.props.data['WITH_POLICY_INTERVENTION_CASE12'],
        policyParams: this.props.data['POLICY_PARAMS'],
        subUseCase: this.props.subUseCase,
        gdpPerCapita: this.props.gdpPerCapita,
        cityPopulation: this.props.cityPopulation,
        travelSplitPublicTransport: this.props.travelSplitPublicTransport,
        travelSplitActiveTravel: this.props.travelSplitActiveTravel
    };

    retrieveInterventions = () => {
        axios.get("/api/pst/interventions?subUseCase=" + this.props.subUseCase.id, {}).then(resp => {
            this.setState({interventions: resp.data});
        });
    }

    back = () => {
        this.props.history.push('/pst');
    }

    onSelectImpact(event) {
        const impact = event.target.value ? parseInt(event.target.value) : null;
        this.setState({impact: impact});
        if (this.state.policyIntervention && impact) {
            this.calculateChartValues(this.state.policyIntervention, impact, this.state.policyYear);
        } else {
            this.setState({data: null});
        }
    }

    onSelectPolicyIntervention(event) {
        let policyIntervention = event.target.value;
        this.setState({policyIntervention: policyIntervention});
        if (this.state.impact && policyIntervention) {
            this.calculateChartValues(policyIntervention, this.state.impact, this.state.policyYear);
        } else {
            this.setState({data: null});
        }
    }

    calculateChartValues(policyIntervention, impact, policyYear) {
        let initialValue;
        let labels = [];
        let values = [];
        let valuesWithout = [];
        let valuesWithoutMap = {};

        this.state.withoutPolicyData.forEach((record) => {
            if (record.impact.id === impact) {
                for (const [key, value] of Object.entries(record.valuesMap)) {
                    labels.push(key);
                    if (key === '2020') {
                        initialValue = value;
                        valuesWithout.push(initialValue);
                        valuesWithoutMap[key] = initialValue;
                        continue;
                    }
                    let calcValue = value == null ? 0 : initialValue + initialValue * value;
                    valuesWithout.push(calcValue);
                    valuesWithoutMap[key] = calcValue;
                }
            }
        });

        let data;

        switch (policyIntervention) {
            case 'BASELINE':
                values = Array(31).fill(0);
                break;
            case 'CASE_1':
                data = this.state.withPolicyDataCase1;
                break;
            case 'CASE_2':
                data = this.state.withPolicyDataCase2;
                break;
            case 'CASE_3':
                data = this.state.withPolicyDataCase3;
                break;
            case 'CASE_4':
                data = this.state.withPolicyDataCase4;
                break;
            case 'CASE_5':
                data = this.state.withPolicyDataCase5;
                break;
            case 'CASE_6':
                data = this.state.withPolicyDataCase6;
                break;
            case 'CASE_7':
                data = this.state.withPolicyDataCase7;
                break;
            case 'CASE_8':
                data = this.state.withPolicyDataCase8;
                break;
            case 'CASE_9':
                data = this.state.withPolicyDataCase9;
                break;
            case 'CASE_10':
                data = this.state.withPolicyDataCase10;
                break;
            case 'CASE_11':
                data = this.state.withPolicyDataCase11;
                break;
            case 'CASE_12':
                data = this.state.withPolicyDataCase12;
                break;
            default:
                break;
        }

        values = this.onComputeWithPolicyValues(data, impact, policyYear, valuesWithoutMap);

        labels.sort();

        this.setState({
            data: {
                labels: labels,
                datasets: [
                    {
                        label: '# of Without Policy Intervention',
                        data: valuesWithout,
                        fill: false,
                        backgroundColor: 'rgba(218, 223, 225)',
                        borderColor: 'rgba(236, 236, 236)',
                        borderWidth: 4
                    },
                    {
                        label: '# of With Policy Intervention',
                        data: values,
                        fill: false,
                        backgroundColor: 'rgb(165, 55, 253)',
                        borderColor: 'rgba(213, 184, 255)',
                        borderWidth: 4
                    },
                ],
            }
        });
    }

    onComputeWithPolicyValues(arr, impact, policyYear, valuesWithoutMap) {
        let values = [];
        let initialValue;
        if (arr) {
            arr.filter((a) => a.impact.id === impact)
                .forEach((record) => {
                    for (const [key, value] of Object.entries(record.valuesMap)) {
                        let withoutImpactValue = valuesWithoutMap[key];
                        let policyEffectiveness = this.state.policyParams.filter((p) => p.type === 'POLICY_EFFECTIVENESS' && p.year === parseInt(key)).map((rec) => {
                            return rec.value;
                        });
                        let policyIntensity = this.state.policyParams.filter((p) => p.type === 'POLICY_INTENSITY' && p.year === parseInt(key)).map((rec) => {
                            return rec.value;
                        });

                        let impactValue;
                        let introductionLag = policyYear - 2020;
                        let targetYear = parseInt(key) - introductionLag;

                        if (key === '2020') {
                            initialValue = value;
                            impactValue = value;
                        } else {
                            if (parseInt(key) >= policyYear) {
                                let val = record.valuesMap[targetYear];
                                if (targetYear === 2020) {
                                    impactValue = val;
                                } else {
                                    impactValue = val == null ? 0 : initialValue + initialValue * val;
                                }
                            }
                        }

                        let calcValue;
                        if (parseInt(key) < policyYear) {
                            calcValue = withoutImpactValue;
                        } else {
                            calcValue = (withoutImpactValue * (1 - policyEffectiveness[0])) + (policyIntensity[0] * policyEffectiveness[0] * impactValue);
                        }

                        values.push(calcValue);
                    }
                });
        }

        return values;
    }

    onSelectPolicyYear(event) {
        let policyYear = event.target.value;
        this.setState({policyYear: policyYear});
        if (this.state.policyIntervention && this.state.impact) {
            this.calculateChartValues(this.state.policyIntervention, this.state.impact, policyYear);
        } else {
            this.setState({data: null});
        }
    }

    retrieveHeaderSubtitle(scenario) {
        let title = '';

        switch (scenario) {
            case 'SCENARIO_1_NO_AUTOMATION':
                title += 'SCENARIO 1 - NO AUTOMATION';
                break;
            case 'SCENARIO_2_PESSIMISTIC':
                title += 'SCENARIO 2 - PESSIMISTIC';
                break;
            case 'SCENARIO_3_NEUTRAL':
                title += 'SCENARIO 3 - NEUTRAL';
                break;
            case 'SCENARIO_4_OPTIMISTIC':
                title += 'SCENARIO 4 - OPTIMISTIC';
                break;
        }

        return title;
    }

    retrieveHeaderTitle(useCase, subUseCase) {
        return subUseCase.description + ' (' + useCase.description + ')';
    }

    retrieveIntroductionLag() {
        return "Introduction lag: " + (this.state.policyYear - 2020);
    }

    calculatePolicyDataCase(record) {
        let result = {};
        for (const [key, value] of Object.entries(record.valuesMap)) {
            if (this.state.subUseCase.nonApplicableImpacts.includes(record.impact.id)) {
                result[key] = 'N/A';
            } else {
                result[key] = key === '2020' ? value : value == null ? '-' : (value * 100).toFixed(2) + "%";
            }
        }

        result.id = record.impact.id;
        result.impact = record.impact.impact;
        result.description = record.impact.description;
        result.measurementUnit = record.impact.measurementUnit;
        result.impactType = record.impact.impactType;

        return result;
    }

    retrievePolicyInterventionCase(typeCase) {
        let intervention =  this.state.interventions.find((intervention) => intervention.typeCase === typeCase);
        return intervention ? intervention.description : null;
    }

    showCalculateButton() {
        if (!this.state.enableSecondMeasure) {
           return  <Row className="mt-4 mb-4">
                <Col xs={12} md={3}>
                    <Link to={{
                        pathname: '/calculator',
                        state: {baselineCase: this.state.withoutPolicyData, chosenCase: this.retrievePolicyData(),
                            gdpPerCapita: this.state.gdpPerCapita, cityPopulation: this.state.cityPopulation,
                            travelSplitActiveTravel: this.state.travelSplitActiveTravel,
                            travelSplitPublicTransport: this.state.travelSplitPublicTransport,
                            subUseCase: this.state.subUseCase, policyYear: this.state.policyYear}
                    }} >
                    <Button
                            disabled={!this.state.policyIntervention || this.state.policyIntervention === 'BASELINE'}
                            variant="outline-primary">Calculate</Button>
                    </Link>
                </Col>
            </Row>
        }
    }

    retrievePolicyData() {
        if (this.state.policyIntervention) {
            let data = null;
            switch (this.state.policyIntervention) {
                case 'CASE_1':
                    data = this.state.withPolicyDataCase1;
                    break;
                case 'CASE_2':
                    data = this.state.withPolicyDataCase2;
                    break;
                case 'CASE_3':
                    data = this.state.withPolicyDataCase3;
                    break;
                case 'CASE_4':
                    data = this.state.withPolicyDataCase4;
                    break;
                case 'CASE_5':
                    data = this.state.withPolicyDataCase5;
                    break;
                case 'CASE_6':
                    data = this.state.withPolicyDataCase6;
                    break;
                case 'CASE_7':
                    data = this.state.withPolicyDataCase7;
                    break;
                case 'CASE_8':
                    data = this.state.withPolicyDataCase8;
                    break;
                case 'CASE_9':
                    data = this.state.withPolicyDataCase9;
                    break;
                case 'CASE_10':
                    data = this.state.withPolicyDataCase10;
                    break;
                case 'CASE_11':
                    data = this.state.withPolicyDataCase11;
                    break;
                case 'CASE_12':
                    data = this.state.withPolicyDataCase12;
                    break;
            }
            return data;
        }
    }

    render() {
        let withPolicyDataCase1Data = this.state.withPolicyDataCase1.map((record) => {
            return this.calculatePolicyDataCase(record);
        });

        let withPolicyDataCase2Data = {};
        let withPolicyDataCase3Data = {};
        let withPolicyDataCase4Data = {};
        let withPolicyDataCase5Data = {};
        let withPolicyDataCase6Data = {};
        let withPolicyDataCase7Data = {};
        let withPolicyDataCase8Data = {};
        let withPolicyDataCase9Data = {};
        let withPolicyDataCase10Data = {};
        let withPolicyDataCase11Data = {};
        let withPolicyDataCase12Data = {};
        let useCase2Exists = this.state.withPolicyDataCase2;
        let useCase3Exists = this.state.withPolicyDataCase3;
        let useCase4Exists = this.state.withPolicyDataCase4;
        let useCase5Exists = this.state.withPolicyDataCase5;
        let useCase6Exists = this.state.withPolicyDataCase6;
        let useCase7Exists = this.state.withPolicyDataCase7;
        let useCase8Exists = this.state.withPolicyDataCase8;
        let useCase9Exists = this.state.withPolicyDataCase9;
        let useCase10Exists = this.state.withPolicyDataCase10;
        let useCase11Exists = this.state.withPolicyDataCase11;
        let useCase12Exists = this.state.withPolicyDataCase12;
        let useCase2Header = null;
        let useCase3Header = null;
        let useCase4Header = null;
        let useCase5Header = null;
        let useCase6Header = null;
        let useCase7Header = null;
        let useCase8Header = null;
        let useCase9Header = null;
        let useCase10Header = null;
        let useCase11Header = null;
        let useCase12Header = null;

        if (useCase2Exists) {
            withPolicyDataCase2Data = this.state.withPolicyDataCase2.map((record) => {
                return this.calculatePolicyDataCase(record);
            });
            useCase2Header = this.retrievePolicyInterventionCase('CASE_2');
        }

        if (useCase3Exists) {
            withPolicyDataCase3Data = this.state.withPolicyDataCase3.map((record) => {
                return this.calculatePolicyDataCase(record);
            });
            useCase3Header = this.retrievePolicyInterventionCase('CASE_3');
        }

        if (useCase4Exists) {
            withPolicyDataCase4Data = this.state.withPolicyDataCase4.map((record) => {
                return this.calculatePolicyDataCase(record);
            });
            useCase4Header = this.retrievePolicyInterventionCase('CASE_4');
        }

        if (useCase5Exists) {
            withPolicyDataCase5Data = this.state.withPolicyDataCase5.map((record) => {
                return this.calculatePolicyDataCase(record);
            });
            useCase5Header = this.retrievePolicyInterventionCase('CASE_5');
        }

        if (useCase6Exists) {
            withPolicyDataCase6Data = this.state.withPolicyDataCase6.map((record) => {
                return this.calculatePolicyDataCase(record);
            });
            useCase6Header = this.retrievePolicyInterventionCase('CASE_6');
        }

        if (useCase7Exists) {
            withPolicyDataCase7Data = this.state.withPolicyDataCase7.map((record) => {
                return this.calculatePolicyDataCase(record);
            });
            useCase7Header = this.retrievePolicyInterventionCase('CASE_7');
        }

        if (useCase8Exists) {
            withPolicyDataCase8Data = this.state.withPolicyDataCase8.map((record) => {
                return this.calculatePolicyDataCase(record);
            });
            useCase8Header = this.retrievePolicyInterventionCase('CASE_8');
        }

        if (useCase9Exists) {
            withPolicyDataCase9Data = this.state.withPolicyDataCase9.map((record) => {
                return this.calculatePolicyDataCase(record);
            });
            useCase9Header = this.retrievePolicyInterventionCase('CASE_9');
        }

        if (useCase10Exists) {
            withPolicyDataCase10Data = this.state.withPolicyDataCase10.map((record) => {
                return this.calculatePolicyDataCase(record);
            });
            useCase10Header = this.retrievePolicyInterventionCase('CASE_10');
        }

        if (useCase11Exists) {
            withPolicyDataCase11Data = this.state.withPolicyDataCase11.map((record) => {
                return this.calculatePolicyDataCase(record);
            });
            useCase11Header = this.retrievePolicyInterventionCase('CASE_11');
        }

        if (useCase12Exists) {
            withPolicyDataCase12Data = this.state.withPolicyDataCase12.map((record) => {
                return this.calculatePolicyDataCase(record);
            });
            useCase12Header = this.retrievePolicyInterventionCase('CASE_12');
        }

        let withoutPolicyDataData = this.state.withoutPolicyData.map((record) => {
            return this.calculatePolicyDataCase(record);
        });

        let renderUseCase2 = function(useCase2Exists, useCaseHeader, withPolicyDataCase2Data) {
            if (useCase2Exists) {
                return (<div className="row policy-result">
                    <h5>With Policy Intervention - {useCaseHeader}</h5>
                    <div className="data-area">
                        <Row>
                            <Col>
                                <DataTable
                                    striped="true"
                                    fixedHeader="true"
                                    fixedHeaderScrollHeight="500px"
                                    columns={columns}
                                    data={withPolicyDataCase2Data}
                                />
                            </Col>
                        </Row>
                    </div>
                </div>)
            }
        }

        let renderUseCase3 = function(useCase3Exists, useCaseHeader, withPolicyDataCase3Data) {
            if (useCase3Exists) {
                return ( <div className="row policy-result">
                    <h5>With Policy Intervention - {useCaseHeader}</h5>
                    <div className="data-area">
                        <Row>
                            <Col>
                                <DataTable
                                    striped="true"
                                    fixedHeader="true"
                                    fixedHeaderScrollHeight="500px"
                                    columns={columns}
                                    data={withPolicyDataCase3Data}
                                />
                            </Col>
                        </Row>
                    </div>
                </div>)
            }
        }

        let renderUseCase4 = function(useCase4Exists, useCaseHeader, withPolicyDataCase4Data) {
            if (useCase4Exists) {
                return ( <div className="row policy-result">
                    <h5>With Policy Intervention - {useCaseHeader}</h5>
                    <div className="data-area">
                        <Row>
                            <Col>
                                <DataTable
                                    striped="true"
                                    fixedHeader="true"
                                    fixedHeaderScrollHeight="500px"
                                    columns={columns}
                                    data={withPolicyDataCase4Data}
                                />
                            </Col>
                        </Row>
                    </div>
                </div>)
            }
        }

        let renderUseRestCase = function(useCaseExists, useCaseHeader, withPolicyData) {
            if (useCaseExists) {
                return ( <div className="row policy-result">
                    <h5>With Policy Intervention - {useCaseHeader}</h5>
                    <div className="data-area">
                        <Row>
                            <Col>
                                <DataTable
                                    striped="true"
                                    fixedHeader="true"
                                    fixedHeaderScrollHeight="500px"
                                    columns={columns}
                                    data={withPolicyData}
                                />
                            </Col>
                        </Row>
                    </div>
                </div>)
            }
        }

        return (
            <Container>
                <div className="row py-2">
                    <a href="" onClick={this.back} className="btn btn-outline-primary btn-sm">Back</a>
                </div>
                <div className="row result-header">
                    <h3>{this.retrieveHeaderTitle(this.props.useCase, this.props.subUseCase)}, {this.retrieveHeaderSubtitle(this.props.scenario)}</h3>
                    {/*<div className="text-center">{this.retrieveHeaderSubtitle(this.props.scenario)}</div>*/}
                </div>
                <Row>
                    <Col xs={12} md={4}>
                        <Form.Group controlId="useCase">
                            <Form.Label>Impact Selection</Form.Label>
                            <Form.Control
                                as="select"
                                onChange={this.onSelectImpact.bind(this)}>
                                <option value="">-- Please Select --</option>
                                <option value="1">Travel Time (min)</option>
                                <option value="2">Vehicle operating cost (€/Km)</option>
                                <option value="3">Freight transport cost (€/tonne.Km)</option>
                                <option value="4">Access to travel</option>
                                <option value="5">Amount of travel (person-km)</option>
                                <option value="6">Congestion (s/veh-km)</option>
                                <option value="7">Modal split of travel using public transport (%)</option>
                                <option value="8">Modal split of travel using active travel (%)</option>
                                <option value="9">Shared mobility rate (%)</option>
                                <option value="10">Vehicle utilisation rate (%)</option>
                                <option value="11">Vehicle occupancy (%)</option>
                                <option value="12">Parking space (m2/person)</option>
                                <option value="14">Energy efficiency (%)</option>
                                <option value="15">NOX due to vehicles (g/veh-km)</option>
                                <option value="16">CO2 due to vehicles (g/veh-km)</option>
                                <option value="17">PM10 due to vehicles (g/veh-km)</option>
                                <option value="18">Public health</option>
                                <option value="19">Accessibility in transport</option>
                                <option value="20">Commuting distances (Km)</option>
                                <option value="21">Unmotorized VRU crash rates (injury-crashes/million veh-km)</option>
                                <option value="22">Road safety motorized (crashes/ million veh-km)</option>
                                <option value="23">Road safety total effect (crashes/ million veh-km)</option>
                            </Form.Control>
                        </Form.Group>
                    </Col>
                    <Col xs={12} md={4}>
                        <Form.Group controlId="policyIntervention">
                            <Form.Label>Policy Intervention (Cases)</Form.Label>
                            <Form.Control
                                as="select"
                                onChange={this.onSelectPolicyIntervention.bind(this)}>
                                <option value="">-- Please Select --</option>
                                {this.state.interventions.map((intervention) => (
                                    <option key={intervention.id} value={intervention.typeCase}>{intervention.description}</option>
                                ))}
                            </Form.Control>
                        </Form.Group>
                    </Col>
                    <Col xs={12} md={4}>
                        <Form.Group controlId="policyYear">
                            <Form.Label>Policy Implementation Year</Form.Label>
                            <Form.Control type="number" placeholder="Policy Implementation Year" min="2020"
                                          max="2050"
                                          required
                                          aria-describedby="policyYear"
                                          defaultValue={this.state.policyYear}
                                          onChange={this.onSelectPolicyYear.bind(this)}/>
                            <Form.Text id="policyYear" muted>
                                {this.retrieveIntroductionLag()}
                            </Form.Text>
                        </Form.Group>
                    </Col>
                </Row>

                {this.showCalculateButton()}
                <div className="row">
                    <Line data={this.state.data} options={options}/>
                </div>
                <div className="row policy-result">
                    <h5>Without Policy Intervention</h5>
                    <div className="data-area">
                        <Row>
                            <Col>
                                <DataTable
                                    striped="true"
                                    fixedHeader="true"
                                    fixedHeaderScrollHeight="500px"
                                    columns={columns}
                                    data={withoutPolicyDataData}
                                />
                            </Col>
                        </Row>
                    </div>
                </div>
                <div className="row policy-result">
                    <h5>With Policy Intervention - {this.retrievePolicyInterventionCase('CASE_1')}</h5>
                    <div className="data-area">
                        <Row>
                            <Col>
                                <DataTable
                                    striped="true"
                                    fixedHeader="true"
                                    fixedHeaderScrollHeight="500px"
                                    columns={columns}
                                    data={withPolicyDataCase1Data}
                                />
                            </Col>
                        </Row>
                    </div>
                </div>
                {renderUseCase2(useCase2Exists, useCase2Header, withPolicyDataCase2Data)}
                {renderUseCase3(useCase3Exists, useCase3Header, withPolicyDataCase3Data)}
                {renderUseCase4(useCase4Exists, useCase4Header, withPolicyDataCase4Data)}
                {renderUseRestCase(useCase5Exists, useCase5Header, withPolicyDataCase5Data)}
                {renderUseRestCase(useCase6Exists, useCase6Header, withPolicyDataCase6Data)}
                {renderUseRestCase(useCase7Exists, useCase7Header, withPolicyDataCase7Data)}
                {renderUseRestCase(useCase8Exists, useCase8Header, withPolicyDataCase8Data)}
                {renderUseRestCase(useCase9Exists, useCase9Header, withPolicyDataCase9Data)}
                {renderUseRestCase(useCase10Exists, useCase10Header, withPolicyDataCase10Data)}
                {renderUseRestCase(useCase11Exists, useCase11Header, withPolicyDataCase11Data)}
                {renderUseRestCase(useCase12Exists, useCase12Header, withPolicyDataCase12Data)}
            </Container>

        )
    }
}

export default PolicySupportToolResult;
